import React from 'react';

const ProgressBar = ({ percentage, color = 'primary' }) => {
  const getColorClass = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary';
      case 'orange':
        return 'bg-orange';
      case 'blue':
        return 'bg-blue';
      default:
        return 'bg-primary';
    }
  };

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div
        className={`${getColorClass(color)} h-2.5 rounded-full transition-all duration-300`}
        style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
